import { render, staticRenderFns } from "./RejectApplication.vue?vue&type=template&id=c78f8c36&scoped=true"
import script from "./RejectApplication.vue?vue&type=script&lang=js"
export * from "./RejectApplication.vue?vue&type=script&lang=js"
import style0 from "./RejectApplication.vue?vue&type=style&index=0&id=c78f8c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78f8c36",
  null
  
)

export default component.exports